import ScansGroupedReport from "./ScansGroupedReport";

export default function ScanByCity() {
  return (
    <ScansGroupedReport
      title="Scan by City"
      subtitle="Scans grouped by the city of the scanned QR / fuel access's retail outlet."
      dimension="city"
      dropdownLabel="City"
      dropdownPlaceholder="All cities"
      dropdownApiPath="/master/cities"
    />
  );
}
